import { apiV2 } from "@/lib/apiV2/apiV2";
import { TAG_TYPE_NAME } from "@/types/tagsV2";
import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";

export const useTagsV2 = (tagTypeName: TAG_TYPE_NAME) => {
  const {
    data: tagsData,
    error: tagsError,
    isFetching: loadingTags,
  } = useQuery({
    queryKey: ["tagsTagType", tagTypeName],
    queryFn: () => apiV2.tags.getByTagType(tagTypeName),
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });

  const tags = tagsData?.data || [];

  const tagOptions = useMemo(
    () =>
      tags.map((tag) => ({
        label: tag.name,
        value: tag.id,
      })),
    [tags]
  );

  return { tags, tagOptions, tagsError, loadingTags };
};
